import React, { createContext, useState, useContext } from "react"
import { HandThumbsUp, XCircleFill } from "react-bootstrap-icons"

const NotificationContext = createContext()
export default NotificationContext
export const useNotifications = () => useContext(NotificationContext)

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([])

  const addNotification = (newNotification) => {
    setNotifications([...notifications, newNotification])
  }

  const removeNotification = (index) => {
    setNotifications(notifications.filter((_, i) => i !== index))
  }

  const success = () => {
    addNotification({
      icon: <HandThumbsUp />,
      variant: "success",
      delay: 1500,
    })
  }

  const failed = (err) => {
    addNotification({
      message: err.toString(),
      icon: <XCircleFill />,
      variant: "danger",
      delay: 10000,
    })
  }

  return <NotificationContext.Provider value={{ notifications, addNotification, removeNotification, success, failed }}>{children}</NotificationContext.Provider>
}

export function withNotif(Component) {
  return function WrapperComponent(props) {
    return <NotificationContext.Consumer>{(NotificationContext) => <Component {...props} notif={NotificationContext} />}</NotificationContext.Consumer>
  }
}
